import PropTypes from 'prop-types';

import { useContext } from "react";

import NotificationContext from "../../context/NotificationContext";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import DownloadIcon from '@mui/icons-material/Download';

const valStyle = {
  fontSize: '40px',
  fontWeight: '600',
};

const PageHeaderWithButton = ({ title, handleDownload }) => {
  const { notificationCount, handleNotificationClick } = useContext(NotificationContext);

  return(
    <Box sx={{display:'flex', justifyContent: 'space-between', mt: 1.5}}>
      <Box>
        <Typography variant="h4" component="div" color="text.secondary" style={valStyle}>
          {title}
        </Typography>
      </Box>
        
      <Box>
        <Button 
          variant="outlined"
          sx={{ marginRight: 0.5 }} 
          color="success"
          startIcon={<DownloadIcon />}
          onClick={handleDownload}
        >
          Export
        </Button>
      </Box>
       
      <Box 
        justifyContent="center"
        alignItems="center"
      >
        <Tooltip title="View notifications" arrow>
          <IconButton
            size="large"
            aria-label="show 17 new notifications"
            color="inherit"
            onClick={handleNotificationClick}
          >
            <Badge badgeContent={notificationCount} color="error">
              <NotificationsIcon 
                color="action"
                style={{
                  width: 30,
                  height: 30,
                }}
              />
            </Badge>
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

PageHeaderWithButton.propTypes = {
  title: PropTypes.string.isRequired,
  handleDownload: PropTypes.func.isRequired,
};

export default PageHeaderWithButton;